<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';

const { t } = useI18n()
</script>

<template>
    <div class="text-center p-2 text-white">{{ t(TEXT.copyright) }}</div>
</template>